const inArray = (value, array) => {
    return array.indexOf(value) > -1;
};

export default inArray;